import {connect} from "react-redux";
import {State} from "../reducers";
import ErrorDialog from "../components/ErrorDialog";
import {createErrorUnselector} from "../utils/selectors";
import {DELETE_SESSION_BASE, POST_OTP_BASE, POST_SESSION_BASE} from "../actions/login";
import {IMPORT_FILE_BASE} from "../actions/products";

const errorSelector = createErrorUnselector([
  POST_SESSION_BASE,
  DELETE_SESSION_BASE,
  POST_OTP_BASE,
  IMPORT_FILE_BASE
]);

const mapStateToProps = (state: State) => ({
  error: errorSelector(state)
});

export default connect(mapStateToProps)(ErrorDialog)
